import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { MarketplacePricingTierPolicyValues as PricingPolicy } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import { log } from '@atlassian/mpac-utils';
import { PER_USER_PRICING_FORMAT_MIN_FRACTION_DIGITS } from "../../../../../../constants";
import { formatAmount } from "../PricingTiers.utils";
export var getAmountText = function getAmountText(amount, currency) {
  return amount > 0 ? formatAmount(amount, {
    currency: currency,
    minimumFractionDigits: PER_USER_PRICING_FORMAT_MIN_FRACTION_DIGITS
  }) : 'Free';
};
export var EXAMPLE_TEAM_SIZES = [20, 50, 75, 100, 200, 500, 750, 1000, 2500, 5000, 7500, 10000, 15000, 20000];
/**
 * Calculate the price of the app for a team of size `users` given a user-tiered per-unit-pricing model.
 * @throws Error when all provided tiers do not cover all `users`.
 */

export var calculatePrice = function calculatePrice(users, tiers) {
  var reverseTiers = _toConsumableArray(tiers).reverse();

  var amount = 0;
  var remainingUsers = users;
  reverseTiers.forEach(function (tier) {
    if (remainingUsers >= tier.floor) {
      var usersInTier = remainingUsers - tier.floor + 1;
      var priceForUsersInTier = usersInTier * tier.amount;
      amount += priceForUsersInTier;
      remainingUsers -= usersInTier;
    }
  });

  if (remainingUsers > 0) {
    throw new Error("Available pricing tiers do not cover all users in team of size ".concat(users));
  }

  return amount;
};
export var createPricingExamples = function createPricingExamples(tiers, currency) {
  var initialTier = tiers[0];
  var initialTierPricing = initialTier.policy === PricingPolicy.Block && initialTier.ceiling ? {
    teamSize: "".concat(initialTier.floor, "-").concat(initialTier.ceiling),
    price: getAmountText(initialTier.amount, currency),
    averagePrice: 'N/A (flat fee)'
  } : null;
  var perUnitTiers = tiers.filter(function (tier) {
    return tier.policy === PricingPolicy.PerUnit;
  }).map(function (tier, index) {
    return index === 0 ? _objectSpread(_objectSpread({}, tier), {}, {
      floor: 1
    }) : tier;
  });
  var examples = EXAMPLE_TEAM_SIZES.map(function (size) {
    try {
      var price = calculatePrice(size, perUnitTiers);
      var averagePrice = price / size;
      return {
        teamSize: size.toString(),
        price: getAmountText(price, currency),
        averagePrice: getAmountText(averagePrice, currency)
      };
    } catch (error) {
      log.warn('[AppListing] Per-User Pricing Examples', error.message || "Failed to calculate price for size ".concat(size));
      return null;
    }
  });
  return [initialTierPricing].concat(_toConsumableArray(examples)).filter(Boolean);
};